$(() => {
  $('.select2').select2({ width: '100%' })
})
